import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-8b036d2a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "no-device-body"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, "不开启设备权限进行身份验证，考试成绩可能无效！", -1);
});
var _hoisted_3 = {
  class: "no-action"
};
var _hoisted_4 = /*#__PURE__*/_createTextVNode("开启权限");
var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 不验证，进入考试 ");
import { CheckerService } from '@/services/device/checker.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var checkerService = useService(CheckerService);
    var startAuth = function () {
      if (checkerService.currentStepIndex !== 0) {
        checkerService.goStep(0);
      } else {
        checkerService.checkStartDevice();
      }
      checkerService.NoDeviceVisible = false;
    };
    var noAuthEntrance = function () {
      checkerService.handleIgnoreCheckStep();
    };
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: _unref(checkerService).NoDeviceVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(checkerService).NoDeviceVisible = $event;
        }),
        closable: true,
        "destroy-on-close": true,
        "mask-closable": false,
        keyboard: false,
        width: 523,
        title: null,
        footer: null,
        centered: "",
        class: "no-device-dialog"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_button, {
            class: "btn",
            onClick: startAuth
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          }), _createVNode(_component_a_button, {
            class: "btn",
            type: "primary",
            onClick: noAuthEntrance
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
});